export default __webpack_public_path__ + "static/media/cctv_activity_in.16d10d84.svg";